import React from 'react';  
import './Section.css';

interface Props {
    children: React.ReactNode;
}

export default class Section extends React.Component<Props, {}> {
	render() {
        return (
            <div className='section'>
                {this.props.children}
            </div>
        );
	}
}